import { Badge } from "antd";
import React from "react";
import { useQuery } from "react-query";
import { api } from "../../services/Api";

const AgentTasksBadge = () => {
  const fetchAgentTasks = async () => {
    // Your fetch logic here
    return api.get(`/tasks/count/agent`);
  };
  const { data, isLoading, isError } = useQuery("agentTasks", fetchAgentTasks, {
    refetchInterval: 10 * 1000, // Refetch every 2 minutes
  });

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching data</div>;

  return (
    <div>
      Agent Created Tasks{" "}
      <Badge
        overflowCount={Infinity} // This prevents the 99+ behavior
        showZero
        count={data?.data}
      ></Badge>
    </div>
  );
};

export default AgentTasksBadge;
